module.exports = __webpack_public_path__ + "images/pages/how-prolaryn/glottal-closure-chart.png";